import { QRCodeSVG } from 'qrcode.react';

const DEFAULT_SIZE = 180;
const DEFAULT_LOGO_SIZE = 34;

function CurrencyQrCode({
  iconUrl = '',
  size = DEFAULT_SIZE,
  value,
}) {
  return (
    <QRCodeSVG
      value={value}
      size={size}
      marginSize={2}
      level="M"
      bgColor="#ffffff"
      fgColor="#111111"
      imageSettings={iconUrl ? {
        src: iconUrl,
        width: DEFAULT_LOGO_SIZE,
        height: DEFAULT_LOGO_SIZE,
        excavate: true,
      } : undefined}
    />
  );
}

export default CurrencyQrCode;
